import React from "react"
import Tippy from "@tippyjs/react"
import "tippy.js/dist/tippy.css"

import { Icone, Texte } from "./index.style"

interface WidgetDescriptionProps {
  description?: unknown
}

/**
 * Info-bulle de DESCRIPTION d'un widget (`widgetProps.description`), à côté de son titre : une
 * explication plus complète que le titre — la règle de calcul d'une vignette, par exemple.
 *
 * ⚠️ Rendue en texte brut, PAS via `InfoBulles` : celui-ci interprète le HTML, et la description est
 * saisie librement dans la configuration du widget.
 */
export default function WidgetDescription({ description }: WidgetDescriptionProps) {
  const texte = typeof description === "string" ? description.trim() : ""
  if (!texte) return null
  return (
    <Tippy content={<Texte>{texte}</Texte>} interactive={false} placement="bottom">
      <Icone role="note" aria-label={texte} onMouseDown={e => e.stopPropagation()}>
        <i className="fa-regular fa-circle-info" />
      </Icone>
    </Tippy>
  )
}
